import React, { useState, useCallback } from "react";
import {
  Form,
  Input,
  DatePicker,
  Table,
  InputNumber,
  Select,
  Upload,
  Button,
  Row,
  Col,
  Card,
  message,
  notification,
  Typography,
  Checkbox,
  Popover,
  Spin,
  Tag,
} from "antd";
import {
  PlusOutlined,
  UploadOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import RequestHandler from "../../util/RequestHandler";
import { odata } from "../Filters/Helper";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { useEffect } from "react";
import { set } from "lodash";
const { Option } = Select;
const { Title, Text } = Typography;

const CreatePurchaseRequest = () => {
  const [form] = Form.useForm();
  const history = useHistory();
  const [materialsData, setMaterialsData] = useState({
    data: [],
    loading: false,
  });
  const [rows, setRows] = useState([]);
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [allCategories, setAllCategories] = useState([]);
  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });

  const [tenantName, setTenantName] = useState("");

  const [firmTransactionProjectTypeList, setFirmTransactionProjectTypeList] =
    useState({
      data: [],
      loading: false,
    });

  const [firmSelected, setFirmSelected] = useState(false);
  const [stockWarehouseMap, setStockWarehouseMap] = useState({});

  const fetchStockWarehouseData = (stockId) => {
    if (!stockId || stockWarehouseMap[stockId]) return;
    setStockWarehouseMap((prev) => ({ ...prev, [stockId]: { loading: true, data: [] } }));
    RequestHandler.get(`/PurchaseRequest/GetStockWarehouseByStockId/${stockId}`).then((res) => {
      setStockWarehouseMap((prev) => ({
        ...prev,
        [stockId]: { loading: false, data: res || [] },
      }));
    });
  };

  useEffect(() => {
    RequestHandler.get(`/PurchaseRequest/GetEntityCode`).then((res) => {
      form.setFieldsValue({ name: res });
    });
    RequestHandler.get(`/MaterialCategory?$top=10000`).then((response) => {
      setAllCategories(response?.value || []);
    });

    RequestHandler.get(
      `/Tenant/GetById/${localStorage.getItem("tenantId")}`,
    ).then((res) => {
      setTenantName(res?.name);
    });

  }, []);

  const getCategoryChildren = useCallback(
    (parentId) => {
      if (parentId === null || parentId === undefined) {
        return allCategories.filter(
          (c) => c.parentId === null || c.parentId === undefined,
        );
      }
      return allCategories.filter((c) => c.parentId === parentId);
    },
    [allCategories],
  );

  const getCategoryAncestors = useCallback(
    (categoryId) => {
      const ancestors = [];
      let current = allCategories.find((c) => c.id === categoryId);
      while (current) {
        ancestors.unshift(current.id);
        current = current.parentId
          ? allCategories.find((c) => c.id === current.parentId)
          : null;
      }
      while (ancestors.length < 5) {
        ancestors.push(null);
      }
      return ancestors.slice(0, 5);
    },
    [allCategories],
  );

  const getDescendantIds = useCallback(
    (categoryId) => {
      const result = [categoryId];
      const queue = [categoryId];
      while (queue.length > 0) {
        const current = queue.shift();
        const children = allCategories.filter((c) => c.parentId === current);
        for (const child of children) {
          result.push(child.id);
          queue.push(child.id);
        }
      }
      return result;
    },
    [allCategories],
  );

  const addRow = () => {
    setRows([
      ...rows,
      {
        key: Date.now(),
        quantity: null,
        unit: "",
        name: "",
        stockCode: "",
        stockId: null,
        materialCategoryId: null,
        cat1Id: null,
        cat2Id: null,
        cat3Id: null,
        cat4Id: null,
        cat5Id: null,
      },
    ]);
  };

  const updateRow = (key, field, value) => {
    setRows((prev) =>
      prev.map((row) => {
        if (row.key === key) {
          const updatedRow = { ...row, [field]: value };

          if (field === "stockId") {
            if (value) {
              const selected = materialsData.data.find((m) => m.id === value);
              if (selected) {
                updatedRow.name = selected.name;
                updatedRow.stockCode = selected.stockCode;
                updatedRow.unit = selected.unit || "";
                updatedRow.materialCategoryId =
                  selected.materialCategoryId || null;
                fetchStockWarehouseData(value);
                if (selected.materialCategoryId) {
                  const ancestors = getCategoryAncestors(
                    selected.materialCategoryId,
                  );
                  updatedRow.cat1Id = ancestors[0];
                  updatedRow.cat2Id = ancestors[1];
                  updatedRow.cat3Id = ancestors[2];
                  updatedRow.cat4Id = ancestors[3];
                  updatedRow.cat5Id = ancestors[4];
                } else {
                  updatedRow.cat1Id = null;
                  updatedRow.cat2Id = null;
                  updatedRow.cat3Id = null;
                  updatedRow.cat4Id = null;
                  updatedRow.cat5Id = null;
                }
              }
            } else {
              updatedRow.materialCategoryId = null;
              updatedRow.cat1Id = null;
              updatedRow.cat2Id = null;
              updatedRow.cat3Id = null;
              updatedRow.cat4Id = null;
              updatedRow.cat5Id = null;
            }
          }

          if (field.startsWith("cat")) {
            const level = parseInt(field.charAt(3), 10);
            for (let i = level + 1; i <= 5; i++) {
              updatedRow[`cat${i}Id`] = null;
            }
          }

          return updatedRow;
        }
        return row;
      }),
    );
  };

  const deleteRow = (key) => {
    setRows((prev) => prev.filter((row) => row.key !== key));
  };

  const categoryColumns = [1, 2, 3, 4, 5].map((level) => ({
    title: `Kategori ${level}`,
    dataIndex: `cat${level}Id`,
    render: (value, record) => {
      const parentField =
        level === 1 ? null : record[`cat${level - 1}Id`];
      if (level > 1 && !parentField) {
        return <Select disabled style={{ minWidth: 140 }} />;
      }
      const options = getCategoryChildren(
        level === 1 ? null : parentField,
      );
      return (
        <Select
          placeholder={`Kategori ${level}`}
          value={value}
          allowClear
          showSearch
          onChange={(val) => updateRow(record.key, `cat${level}Id`, val)}
          style={{ minWidth: 140 }}
          filterOption={(input, option) =>
            option.children
              .toLocaleLowerCase("tr-TR")
              .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
          }
        >
          {options.map((c) => (
            <Option key={c.id} value={c.id}>
              {c.name}
            </Option>
          ))}
        </Select>
      );
    },
  }));

  const columns = [
    ...categoryColumns,
    {
      title: "Malzeme",
      dataIndex: "stockId",
      render: (value, record) => (
        <Select
          placeholder="(Opsiyonel). En az 2 harf giriniz.."
          value={value}
          allowClear
          showSearch
          onSearch={(val) => onMaterialSearch(val, record)}
          onChange={(val) => updateRow(record.key, "stockId", val)}
          style={{ width: "100%" }}
          filterOption={(input, option) =>
            option.children
              .toLocaleLowerCase("tr-TR")
              .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
          }
        >
          {materialsData?.data?.map((m) => (
            <Option key={m.id} value={m.id}>
              {m.name}
            </Option>
          ))}
        </Select>
      ),
    },
    {
      title: "Stok Kodu",
      dataIndex: "stockCode",
      render: (value, record) => (
        <Input
          value={value}
          readOnly={true}
        />
      ),
    },
    {
      title: "Miktar",
      dataIndex: "quantity",
      render: (value, record) => (
        <InputNumber
          min={0}
          value={value}
          onChange={(val) => updateRow(record.key, "quantity", val)}
          className="ant-input"
          decimalSeparator=","
          thousandSeparator="."
        />
      ),
    },
    {
      title: "Birim",
      dataIndex: "unit",
      render: (value, record) => (
        <Input
          value={value}
          readOnly={true}
          onChange={(e) => updateRow(record.key, "unit", e.target.value)}
        />
      ),
    },
    {
      title: "Mevcut Stok",
      dataIndex: "stockId",
      key: "stockInfo",
      width: 120,
      render: (stockId) => {
        if (!stockId) return null;
        const info = stockWarehouseMap[stockId];
        if (!info) return null;
        if (info.loading) return <Spin size="small" />;
        if (!info.data || info.data.length === 0)
          return <Tag color="orange">Stok Yok</Tag>;
        const totalCount = info.data.reduce(
          (sum, w) => sum + (w.count || 0),
          0,
        );
        const content = (
          <div>
            {info.data.map((w) => (
              <div
                key={w.id}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 16,
                  padding: "4px 0",
                  borderBottom: "1px solid #f0f0f0",
                }}
              >
                <span>{w.name || w.projectCode || "Depo"}</span>
                <strong>{w.count}</strong>
              </div>
            ))}
          </div>
        );
        return (
          <Popover
            content={content}
            title="Depo Bazlı Stok"
            trigger="click"
          >
            <Tag
              color="blue"
              style={{ cursor: "pointer" }}
            >
              <InfoCircleOutlined /> {totalCount}
            </Tag>
          </Popover>
        );
      },
    },
    {
      title: "Sil",
      key: "action",
      render: (_, record) => (
        <Button
          danger
          type="link"
          icon={<DeleteOutlined />}
          onClick={() => deleteRow(record.key)}
        ></Button>
      ),
    },
  ];

  const onSuccess = () => {
    form.resetFields();
    setFiles([]);
    setTimeout(
      function () {
        history.push(`/purchase-request-list`);
      }.bind(this),
      2000,
    );
  };

  const onFinish = (values) => {
    const stockCounts = {};
    const duplicateRows = [];

    rows.forEach((row) => {
      if (row.stockId) {
        stockCounts[row.stockId] = (stockCounts[row.stockId] || 0) + 1;
        if (stockCounts[row.stockId] === 2) {
          duplicateRows.push(row);
        }
      }
    });

    if (duplicateRows.length > 0) {
      duplicateRows.forEach((row) => {
        setLoading(false);
        notification.error({
          message: "Mükerrer Ürün",
          description: `${row.name} malzemesi listede birden çok bulunuyor. Lütfen kontrol ediniz.`,
          placement: "topRight",
        });
      });
      return;
    }
    const invalidRows = rows.filter((row) => {
      const hasMaterial = row.stockId || (row.name && row.name.trim() !== "");
      const validQuantity =
        typeof row.quantity === "number" && row.quantity > 0;
      const hasUnit = row.unit && row.unit.trim() !== "";

      return !hasMaterial || !validQuantity || !hasUnit;
    });

    if (invalidRows.length > 0) {
      invalidRows.forEach((row) => {
        setLoading(false);
        notification.error({
          message: "Hatalı Malzeme Satırı",
          description:
            row.name && row.name.trim() !== ""
              ? `${row.name} satırında eksik veya hatalı bilgi var.`
              : `Malzeme Adı belirtilmemiş satırda eksik veya hatalı bilgi var.`,
          placement: "topRight",
        });
      });
      return;
    }

    const payload = {
      ...values,
      desiredDeliveryDate: values.desiredDeliveryDate
        ? values.desiredDeliveryDate.format("YYYY-MM-DD")
        : null,
      purchaseRequestItemDtos: rows,
    };

    const formData = new FormData();
    formData.append("jsonString", JSON.stringify(payload));
    files.forEach((file) => {
      formData.append("files", file.originFileObj);
    });

    RequestHandler.post(
      `/PurchaseRequest`,
      formData,
      true,
      {},
      "multipart/form-data",
    ).then((response) => {
      setLoading(false);
      if (response.success) {
        onSuccess();
      }
    });
  };

  const onMaterialSearch = (value, record) => {
    if (value.length >= 2) {
      setMaterialsData({ data: [], loading: true });

      let filterParts = [
        `(${odata.contains("name", value)} or ${odata.contains("stockCode", value)})`,
      ];

      const deepestCatId =
        record.cat5Id ||
        record.cat4Id ||
        record.cat3Id ||
        record.cat2Id ||
        record.cat1Id;

      if (deepestCatId) {
        const descendantIds = getDescendantIds(deepestCatId);
        const catFilter = descendantIds
          .map((id) => `materialCategoryId eq ${id}`)
          .join(" or ");
        filterParts.push(`(${catFilter})`);
      }

      RequestHandler.get(
        `/PurchaseRequest/GetStockList?$select=id,name,stockCode,materialCategoryId,materialCategoryName,unit&$filter=${filterParts.join(" and ")}`,
      ).then((res) => {
        setMaterialsData({ data: res, loading: false });
      });
    } else {
      setMaterialsData({ data: [], loading: false });
    }
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  const onFirmSearch = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ data: [], loading: true });

      RequestHandler.get(
        `/PurchaseRequest/GetFirmList?$select=id,firmBranchNumber,name&$filter=${odata.contains(
          "name",
          value,
        )} or ${odata.contains("firmBranchNumber", value)}`,
      ).then((res) => {
        setFirmSelect({ data: res, loading: false });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };

  const onChangeFirm = (value) => {
    if (value) {
      setFirmTransactionProjectTypeList({ data: [], loading: true });
      RequestHandler.get(
        `/FirmTransactionProjectType/GetListByFirmId/${value}`,
      ).then((res) => {
        setFirmTransactionProjectTypeList({ data: res, loading: false });
      });
      setFirmSelected(true);
    } else {
      setFirmTransactionProjectTypeList({ data: [], loading: false, data: [] });
      setFirmSelected(false);
    }
  };

  return (
    <Form
      form={form}
      name="create-purchase-request"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row justify="center" style={{ padding: 20, paddingLeft: "20%" }}>
        <Col xs={24} md={20} lg={24}>
          <Form form={form} layout="vertical" onFinish={onFinish}>
            <Row gutter={[16, 16]}>
              <Col xs={24} md={18}>
                <Card
                  title={
                    <span style={{ fontWeight: "bold", fontSize: 18 }}>
                      Talep Bilgileri
                    </span>
                  }
                  bordered={false}
                >
                  <Form.Item
                    label="Talep Kodu :"
                    name="name"
                    rules={[{ required: true, message: "Lütfen kod giriniz" }]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Talep Başlığı :"
                    name="description"
                  >
                    <Input.TextArea rows={3} />
                  </Form.Item>

                  <Form.Item
                    label="Proje Adı/Ünvanı :"
                    name="firmId"
                    rules={[
                      { required: true, message: "Lütfen proje seçiniz." },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="En az 2 harf giriniz.."
                      onSearch={onFirmSearch}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                        option.code
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={firmSelect.loading}
                      onChange={onChangeFirm}
                    >
                      {firmSelect.data.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                          code={item.firmBranchNumber}
                        >
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="Teslimat Deposu :"
                    name="transactionProjectTypeId"
                    rules={[
                      {
                        required: firmSelected,
                        message: "Lütfen teslimat deposu seçiniz.",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Teslimat Deposu"
                      allowClear
                      showSearch
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={firmTransactionProjectTypeList.loading}
                    >
                      {firmTransactionProjectTypeList.data.map((item) => (
                        <Select.Option
                          key={item.transactionProjectTypeId}
                          value={item.transactionProjectTypeId}
                        >
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="İstenen Teslim Tarihi :"
                    name="desiredDeliveryDate"
                  >
                    <DatePicker
                      format="YYYY-MM-DD"
                      style={{ width: "30%" }}
                      disabledDate={(current) => {
                        return current && current < moment().startOf("day");
                      }}
                    />
                  </Form.Item>

                  <Form.Item
                    label="Malzeme Alım Amacı ve Kullanilacağı Yer :"
                    name="purposeOfPurchasing"
                  >
                    <Input.TextArea rows={3} />
                  </Form.Item>
                </Card>

                <Card
                  title={
                    <span style={{ fontWeight: "bold", fontSize: 18 }}>
                      Talep Malzemeleri
                    </span>
                  }
                  bordered={false}
                  style={{ marginTop: 16 }}
                >
                  <Button
                    type="dashed"
                    onClick={addRow}
                    icon={<PlusOutlined />}
                    style={{ marginBottom: 10 }}
                  >
                    Satır Ekle
                  </Button>
                  <Table
                    columns={columns}
                    dataSource={rows}
                    pagination={false}
                    rowKey="key"
                    scroll={{ x: "max-content" }}
                  />

                  <br></br>
                  <br></br>
                  <Form.Item
                    label={
                      <span style={{ fontWeight: "bold" }}>
                        Malzeme Hakkında Açıklama, Teknik Detaylar ve Varsa
                        Marka Bilgileri :
                      </span>
                    }
                    name="detailedDescription"
                  >
                    <Input.TextArea rows={6} />
                  </Form.Item>
                </Card>

                <Card
                  title={
                    <span style={{ fontWeight: "bold", fontSize: 18 }}>
                      Dosyalar
                    </span>
                  }
                  bordered={false}
                  style={{ marginTop: 16 }}
                >
                  <Upload
                    multiple
                    beforeUpload={() => false}
                    onChange={({ fileList }) => setFiles(fileList)}
                    fileList={files}
                  >
                    <Button icon={<UploadOutlined />}>Dosya Yükle</Button>
                  </Upload>
                </Card>

                <Row justify="space-between">
                  <Col span={24} style={{ textAlign: "right" }}>
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      htmlType="submit"
                      loading={loading}
                    >
                      Talep Ekle
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </Form>
  );
};

export default CreatePurchaseRequest;
